export default {
  demographic: {
    pageTitle: 'Demographics',
    pageId: 'metrics',
    layout: [
      [
        {
          id: 'dpn_breakout_by_gender',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client_by_gender',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services_per_closed_client']
        }
      ],
      [
        {
          id: 'services_by_gender',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'dpn_breakout_by_ethnicity',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client_by_ethnicity',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services_per_closed_client']
        }
      ],
      [
        {
          id: 'services_by_ethnicity',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'dpn_breakout_by_age',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client_by_age',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services_per_closed_client']
        }
      ],
      [
        {
          id: 'services_by_age',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'dpn_breakout_by_living_situation',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client_by_living_situation',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services_per_closed_client']
        }
      ],
      [
        {
          id: 'services_by_living_situation',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'dpn_breakout_by_parenting_status',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client_by_parenting_status',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services_per_closed_client']
        }
      ],
      [
        {
          id: 'services_by_parenting_status',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'dpn_breakout_by_insurance_type',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client_by_insurance_type',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services_per_closed_client']
        }
      ],
      [
        {
          id: 'services_by_insurance_type',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ]
    ]
  },

  geo: {
    pageTitle: 'Geography',
    pageId: 'metrics',
    layout: [
      [
        {
          id: 'dpn_breakout_by_zip_map',
          defaultSide: 'chart-side',
          chartType: 'map',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'dpn_breakout_by_city',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client_by_city',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services_per_closed_client']
        }
      ],
      [
        {
          id: 'services_by_city',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'dpn_breakout_by_zip',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client_by_zip',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services_per_closed_client']
        }
      ],
      [
        {
          id: 'services_by_zip',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'dpn_breakout_by_eligibility',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client_by_eligibility',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services_per_closed_client']
        }
      ],
      [
        {
          id: 'services_by_eligibility',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ]
    ]
  },

  cbo_insights: {
    pageTitle: 'Partner Insights',
    pageId: 'metrics',
    layout: [
      [
        {
          id: 'clients_by_cbo',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['total_clients']
        }
      ],
      [
        {
          id: 'probation_referrals_by_cbo',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['total_referrals']
        }
      ],
      [
        {
          id: 'total_services_for_closed_clients_by_cbo',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['total_services_for_closed_clients']
        }
      ],
      // [
      //   {
      //     id: 'clients_min_one_session_monthly',
      //     defaultSide: 'chart-side',
      //     chartType: 'line',
      //     yAxis: ['count']
      //   }
      // ],
      [
        {
          id: 'clients_min_one_session_by_cbo',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['total_clients']
        }
      ]
      // [
      //   {
      //     id: 'services_per_closed_client_per_cbo',
      //     defaultSide: 'chart-side',
      //     chartType: 'bar',
      //     yAxis: ['avg_services_per_closed_client'],
      //   },
      // ],
      // [
      //   {
      //     id: 'outcomes_by_cbo',
      //     defaultSide: 'chart-side',
      //     chartType: 'stackedBar',
      //     yAxis: ['successful', 'unknown', 'unsuccessful'],
      //   },
      // ],
    ]
  },
  referrals: {
    pageTitle: 'Entry',
    pageId: 'metrics',
    layout: [
      // Referral Type
      // [
      //   {
      //     id: 'dpn_breakout_by_referral_type',
      //     defaultSide: 'chart-side',
      //     chartType: 'bar',
      //     yAxis: ['count']
      //   }
      // ],
      // [
      //   {
      //     id: 'services_per_closed_client_by_referral_type',
      //     defaultSide: 'chart-side',
      //     chartType: 'bar',
      //     yAxis: ['avg_services_per_closed_client']
      //   }
      // ],
      // [
      //   {
      //     id: 'services_by_referral_type',
      //     defaultSide: 'chart-side',
      //     chartType: 'stackedBar',
      //     yAxis: ['count']
      //   }
      // ],
      // Referral Source
      [
        {
          id: 'dpn_breakout_by_referral_source',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client_by_referral_source',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services_per_closed_client']
        }
      ],
      [
        {
          id: 'services_by_referral_source',
          defaultSide: 'chart-side',
          chartType: 'stackedBar',
          yAxis: ['count']
        }
      ],
      // School District
      [
        {
          id: 'dpn_breakout_by_school_district',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client_by_school_district',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services_per_closed_client']
        }
      ],
      [
        {
          id: 'services_by_school_district',
          defaultSide: 'chart-side',
          chartType: 'stackedBar',
          yAxis: ['count']
        }
      ],
      // OUSD
      [
        {
          id: 'dpn_breakout_by_ousd',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client_by_ousd',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services_per_closed_client']
        }
      ],
      [
        {
          id: 'services_by_ousd',
          defaultSide: 'chart-side',
          chartType: 'stackedBar',
          yAxis: ['count']
        }
      ]
    ]
  },
  program_summary: {
    pageTitle: 'Program Summary',
    pageId: 'metrics',
    layout: [
      // High Level Client Aggregations
      [
        {
          id: 'unique_dpn_clients',
          defaultSide: 'chart-side',
          chartType: 'line',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'open_closed',
          defaultSide: 'chart-side',
          chartType: 'line',
          yAxis: ['count', 'count']
        }
      ],
      // Referral Information
      // [
      //   {
      //     id: 'clients_by_referral_type_new',
      //     defaultSide: 'chart-side',
      //     chartType: 'bar',
      //     yAxis: ['total_clients']
      //   }
      // ],
      [
        {
          id: 'clients_by_referral_source_new',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['total_clients']
        }
      ],
      // Demographic & Geographic Information
      [
        {
          id: 'clients_by_ethnicity',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['total_clients']
        }
      ],
      [
        {
          id: 'clients_by_city',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['total_clients']
        }
      ],
      // Education Information
      [
        {
          id: 'clients_by_ousd',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['total_clients'],
          options: {
            scales: {
              y: {
                beginAtZero: true,
                ticks: {
                  precision: 0 // Only show whole numbers
                }
              }
            }
          }
        }
      ],
      [
        {
          id: 'clients_by_school_district',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['total_clients'],
          options: {
            scales: {
              y: {
                beginAtZero: true,
                ticks: {
                  precision: 0 // Only show whole numbers
                }
              }
            }
          }
        }
      ],
      // Service Volume & Outcomes
      [
        {
          id: 'clients_by_service_type',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['clients']
        }
      ],
      [
        {
          id: 'total_services_provided_by_type',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'services_per_closed_client',
          defaultSide: 'chart-side',
          chartType: 'line',
          yAxis: ['avg']
        }
      ],
      [
        {
          id: 'services_per_closed_client_counseling_only',
          defaultSide: 'chart-side',
          chartType: 'line',
          yAxis: ['avg']
        }
      ],      
      [
        {
          id: 'services_per_closed_client_by_type',
          defaultSide: 'chart-side',
          chartType: 'line',
          yAxis: ['avg', 'avg', 'avg', 'avg', 'avg', 'avg', 'avg']
        }
      ],
      [
        {
          id: 'cbo_outcomes',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['clients']
        }
      ]
    ]
  },
  truancy: {
    pageTitle: 'Truancy (Legacy)',
    pageId: 'metrics',
    desc: '',
    layout: [
      [
        {
          id: 'truancy_outcomes_for_all_clients',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count'],
          desiredOutcome: 'Increase in Not Truant, decrease in Truant'
        }
      ],
      [
        {
          id: 'truancy_outcomes_for_truants',
          defaultSide: 'chart-side',
          chartType: 'doughnut',
          yAxis: ['unique_clients'],
          desiredOutcome: 'Larger piece of pie for Not Truant'
        }
      ],
      // [
      //   {
      //     id: 'truancy_improvement_by_cbo',
      //     defaultSide: 'chart-side',
      //     chartType: 'bar',
      //     yAxis: ['count'],
      //     desiredOutcome: 'Decline in truancy from start to close',
      //   },
      // ],
      [
        {
          id: 'impact_on_truancy',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg']
        }
      ],
      [
        {
          id: 'truancy_by_gender',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count'],
          desiredOutcome: 'Truant bars down, Not Truant bars up'
        },
        {
          id: 'truancy_by_ethnicity',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count'],
          desiredOutcome: 'Truant bars down, Not Truant bars up'
        }
      ]
    ]
  },

  gpa: {
    pageTitle: 'GPA (Legacy)',
    pageId: 'metrics',
    desc: '',
    layout: [
      [
        {
          id: 'gpa_improvement_for_DPN',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_gpa'],
          desiredOutcome: 'Increase in GPA at close'
        }
      ],
      // [
      //   {
      //     id: 'avg_gpa_improvement_by_cbo',
      //     defaultSide: 'chart-side',
      //     chartType: 'bar',
      //     yAxis: ['avg_gpa'],
      //     desiredOutcome: 'Increase in GPA at close',
      //   },
      // ],
      [
        {
          id: 'dpn_services_impact_gpa',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg']
        }
      ],
      [
        {
          id: 'avg_gpa_improvement_by_gender',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_gpa'],
          desiredOutcome: 'Increase in GPA at close'
        },
        {
          id: 'avg_gpa_improvement_by_ethnicity',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_gpa'],
          desiredOutcome: 'Increase in GPA at close'
        }
      ],
      [
        {
          id: 'gpa_changes_by_successful_outcomes',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_gpa'],
          desiredOutcome: 'Increase in GPA at close'
        }
      ]
    ]
  },

  pcoms: {
    pageTitle: 'PCOMS',
    pageId: 'metrics',
    desc: '',
    layout: [
      [
        {
          id: 'pcom_individual_score_pre_and_post',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_score']
          // desiredOutcome: 'Increase in GPA at close',
        }
      ],
      [
        {
          id: 'pcom_family_score_pre_and_post',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_score']
          // desiredOutcome: 'Increase in GPA at close',
        }
      ],
      // [
      //   {
      //     id: 'individual_improvement_outcomes',
      //     defaultSide: 'chart-side',
      //     chartType: 'bar',
      //     yAxis: ['clients']
      //     // desiredOutcome: 'Increase in GPA at close',
      //   }
      // ],
      // [
      //   {
      //     id: 'family_improvement_outcomes',
      //     defaultSide: 'chart-side',
      //     chartType: 'bar',
      //     yAxis: ['clients']
      //     // desiredOutcome: 'Increase in GPA at close',
      //   }
      // ]
    ]
  },

  recidivism: {
    pageTitle: 'Arrests',
    pageId: 'metrics',
    desc:
      'The goal of this dashboard is to show the impact of the DPN on client arrest rates. For the purposes of this dashboard, arrested DPN clients are defined as clients who have a DPN Closing Date occuring in the past year as provided by a DPN agency partner.',
    layout: [
      [
        {
          id: 'client_arrests_over_timeperiod',
          defaultSide: 'chart-side',
          chartType: 'line',
          yAxis: ['count', 'count']
        }
      ],
      [
        {
          id: 'arrests_by_arrested_offense_dpn',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['arrests']
        }
      ],
      [
        {
          id: 'arrests_by_arrested_offense_non_dpn',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['arrests']
        }
      ],
      [
        {
          id: 'arrest_by_crimes_dpn',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['arrests']
        }
      ],
      [
        {
          id: 'arrest_by_crimes_non_dpn',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['arrests']
        }
      ],
      [
        {
          id: 'impact_of_dpn_on_kids_recidivism',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['percent_rearrested'],
          desiredOutcome: 'Lower percentage of rearrests for DPN clients'
        }
      ],
      [
        {
          id: 'impact_of_dpn_on_repeat_arrest',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg'],
          desiredOutcome: 'Lower rate of rearrests for DPN clients'
        }
      ],
      [
        {
          id: 'dpn_impact_before_after_closing_date',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['percent_of_clients_arrested'],
          desiredOutcome: 'Lower rate of arrests after closing'
        }
      ],
      [
        {
          id: 'services_arrested_kids_took',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_services']
        }
      ],
      [
        {
          id: 'repeated_arrest',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count']
        }
      ],
      [
        {
          id: 'successful',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg']
        }
      ],
      [
        {
          id: 'service_patterns_by_violent',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg']
        }
      ],
      [
        {
          id: 'service_patterns_by_felony',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg']
        }
      ],
      [
        {
          id: 'service_patterns_by_misdemeanor',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg']
        }
      ]
    ]
  },

  fiscal_analysis: {
    title: 'Fiscal Analysis',
    pageId: 'fiscal',
    desc: 'for Alameda Probation only',
    layout: [
      [
        {
          id: 'annual_contract_size',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['contract']
        }
      ],
      [
        {
          id: 'cost_per_clients_by_cbo',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['cost']
        }
      ],
      [
        {
          id: 'cost_per_total_services_for_closed_clients_by_cbo',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['cost']
        }
      ]
    ]
  },

  success: {
    pageTitle: 'Success Metrics',
    pageId: 'metrics',
    layout: [
      [
        {
          id: 'pcom_individual_score_pre_and_post',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_score'],
          title: 'Individual PCOMS Scores',
          description: 'Average individual PCOMS scores at start and close'
        }
      ],
      [
        {
          id: 'pcom_family_score_pre_and_post',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['avg_score'],
          title: 'Family PCOMS Scores',
          description: 'Average family PCOMS scores at start and close'
        }
      ],
      [
        {
          id: 'individual_improvement_outcomes',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['clients'],
          title: 'Individual PCOMS Outcomes',
          description: 'Distribution of individual PCOMS improvement outcomes'
        }
      ],
      [
        {
          id: 'family_improvement_outcomes',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['clients'],
          title: 'Family PCOMS Outcomes',
          description: 'Distribution of family PCOMS improvement outcomes'
        }
      ],
      [
        {
          id: 'successful_completion',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count'],
          title: 'Program Completion Status',
          description: 'Distribution of program completion outcomes'
        }
      ],
      [
        {
          id: 'arrested_during_intervention',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count'],
          title: 'Arrests During Intervention',
          description: 'Number of clients arrested during program participation'
        }
      ],
      [
        {
          id: 'incarcerated_during_intervention',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count'],
          title: 'Incarceration During Intervention',
          description: 'Number of clients incarcerated during program participation'
        }
      ],
      [
        {
          id: 'completed_community_service',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count'],
          title: 'Community Service Completion',
          description: 'Distribution of community service completion status'
        }
      ]
    ]
  },

  cp_metrics: {
    pageTitle: 'Community Programs Metrics',
    pageId: 'metrics',
    description: 'These charts display metrics specific to Community Programs (CP) data. They are only visible when the CP agency type filter is selected.',
    layout: [
      [
        {
          id: 'cp_client_status_breakdown',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['clients'],
          title: 'Client Status Breakdown',
          description: 'Distribution of clients by status: At Promise, On Probation, TAY'
        }
      ],
      [
        {
          id: 'cp_assessment_type_breakdown',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['clients'],
          title: 'Assessment Type Breakdown',
          description: 'Distribution of clients by type of assessment administered'
        }
      ],
      [
        {
          id: 'cp_contact_attempt_funnel',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['count'],
          title: 'Contact Attempt Funnel',
          description: 'Client engagement progression from referral through first service delivery'
        }
      ],
      [
        {
          id: 'cp_type_of_contact_breakdown',
          defaultSide: 'chart-side',
          chartType: 'bar',
          yAxis: ['clients'],
          title: 'Type of Initial Contact',
          description: 'Distribution of initial contact methods: Phone Call, School Visit, Community Visit, Collateral Contact, Other'
        }
      ]
    ]
  }
};
